import { css, cx } from "@emotion/css"
import { useI18n } from "providers/I18n"
import { Loading } from "components/Loading"

import {
  compactThousandsSeparated,
  compactSmall,
} from "../../helpers/formatters"

const stylesWidgetStats = {
  root: css`
    color: var(--white);
    display: flex;
    flex-direction: column;
    align-items: center;
    width: fit-content;
    min-width: 204px;
    height: 256px;
    padding: var(--spacing-xl) var(--spacing-xxl-2);
    border-radius: 20px;
    background-color: var(--grey-opacity);
    justify-content: center;
  `,
  value: css`
    font-weight: 300;
    font-size: 25px;
  `,
  title: css`
    margin-bottom: 20px;
  `,
  detail: css`
    opacity: 0.85;
  `,
}

export type WidgetStatsType = {
  value?: number
  percentage?: number
  isLoading?: boolean
}
export const WidgetStats = (props: WidgetStatsType) => {
  const { t } = useI18n()

  return (
    <>
      <div className={stylesWidgetStats.root}>
        {props.isLoading ? (
          <Loading />
        ) : (
          <>
            <span className={cx("HeadingH3Black", stylesWidgetStats.value)}>
              {props.value &&
                compactThousandsSeparated(Math.round(props.value))}
            </span>
            <span className={cx("HeadingH5bBold", stylesWidgetStats.title)}>
              {t("revenue.headcount")}
            </span>
            <span className={cx("HeadingH6Regular", stylesWidgetStats.detail)}>
              {props.percentage !== null
                ? `${compactSmall(props.percentage)}% ${t("revenue.yoygrowth")}`
                : "N/A"}
            </span>
          </>
        )}
      </div>
    </>
  )
}
